import * as React from 'react';
export class BinaryLinkSegmentWidget extends React.Component {
  render() {
    const Bottom = /*#__PURE__*/React.cloneElement(this.props.factory.generateLinkSegment(this.props.link, this.props.selected || this.props.link.isSelected(), this.props.path), {
      ref: this.props.forwardRef
    });
    const Top = /*#__PURE__*/React.cloneElement(Bottom, {
      strokeLinecap: 'round',
      onMouseLeave: () => {
        this.props.onSelection(false);
      },
      onMouseEnter: () => {
        this.props.onSelection(true);
      },
      ...this.props.extras,
      ref: null,
      'data-linkid': this.props.link.getID(),
      strokeOpacity: this.props.selected ? 0.1 : 0,
      strokeWidth: 20,
      fill: 'none',
      onContextMenu: event => {
        if (!this.props.link.isLocked()) {
          event.preventBinary();
          this.props.link.remove();
        }
      }
    });
    return /*#__PURE__*/React.createElement("g", null, Bottom, Top);
  }

}